import { ThemeOptions } from '@mui/material';

export const MuiTimelineOppositeContent: ThemeOptions['components']['MuiTimelineOppositeContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary
    })
  }
};
